import { render } from "./UserDetails.vue?vue&type=template&id=1764f0ca&ts=true"
import script from "./UserDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDetails.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Company/UserDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1764f0ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1764f0ca', __exports__)) {
    console.log('reload')
    api.reload('1764f0ca', __exports__)
  }
  
  module.hot.accept("./UserDetails.vue?vue&type=template&id=1764f0ca&ts=true", () => {
    console.log('re-render')
    api.rerender('1764f0ca', render)
  })

}


export default __exports__